import { logUsage } from 'owa-analytics';
import isInConversationView from './isInConversationView';
import { isSubjectPickerSupported } from './isSubjectPickerSupported';

export function logSubjectPickerInitInfo(): void {
    if (isSubjectPickerSupported()) {
        logUsage(
            'SubjectPicker_Init',
            {
                isConversationView: isInConversationView(),
            },
            {
                // This is temporary to get data in MSIT. Should be removed before starting Prod rollout
                // https://msfast.visualstudio.com/FAST/Office%20People%20HD/_workitems/edit/253222
                isCore: true,
            }
        );
    }
}
